import * as React from 'react';
import * as Actions from './actions/Actions';
import { connect } from 'react-redux';
import { IPaymentJournal } from './Entities';
import { Button, Modal, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import PaymentJournalList from './list/PaymentJournalList';
import * as Site from '../../shared/Site';

interface IPaymentJournalModal {
    html: any;
}

interface ILegalEntity {
    id: number;
    name: string;
    site: number;
    numberOfNewPayments: number;
    paymentJournals: IPaymentJournal[];
}

interface IProps {
    paymentJournal: IPaymentJournalModal;
    legalEntities: ILegalEntity[];
    actions: IActions;
}

interface IState {
    showPaymentJournal: boolean;
}

class PaymentJournalsPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showPaymentJournal: false
        };

        this.viewPaymentJournal = this.viewPaymentJournal.bind(this);
        this.closePaymentJournal = this.closePaymentJournal.bind(this);
    }

    componentDidMount() {
        this.props.actions.getList();
    }

    viewPaymentJournal(id: number) {
        this.props.actions
            .view(id)
            .then(() => {
                this.setState({ showPaymentJournal: true } as IState);
            })
            .catch(handleError);
    }

    closePaymentJournal() {
        this.setState({ showPaymentJournal: false } as IState);
    }

    render() {
        return (
            <div>
                <Tab.Container defaultActiveKey={0} id="uncontrolled-tab">
                    <div>
                        <Nav bsStyle="tabs">
                            {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                                <NavItem eventKey={index} key={'legal-entity-nav-item-' + index}>
                                    {`${x.name} - ${
                                        x.site === Site.Scandphotos ? 'Scandphotos' : 'SE360'
                                    }`}{' '}
                                    {x.numberOfNewPayments > 0 ? `(${x.numberOfNewPayments})` : ''}
                                </NavItem>
                            ))}
                        </Nav>
                        <Tab.Content>
                            {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                                <Tab.Pane eventKey={index} key={'legal-entity-tab-' + index}>
                                    <div>
                                        <Button
                                            onClick={() => this.props.actions.create(x.id, x.site)}
                                            bsStyle="success"
                                            disabled={x.numberOfNewPayments < 1}
                                        >
                                            {Translate('payment-journal/create/button', {
                                                numberOfNewPayments: x.numberOfNewPayments
                                            })}
                                        </Button>
                                        <PaymentJournalList
                                            list={x.paymentJournals}
                                            view={this.viewPaymentJournal}
                                        />
                                    </div>
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </div>
                </Tab.Container>

                {this.state.showPaymentJournal && this.props.paymentJournal && (
                    <Modal show={true} onHide={this.closePaymentJournal} bsSize="large">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {Translate('payment-journal/view/modal/title')}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="invoice-modal-row">
                                <Col xs={12} lg={9} className="invoice-preview-column">
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.paymentJournal.html
                                        }}
                                    ></div>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closePaymentJournal}>
                                {Translate('payment-journal/view/modal/button/close')}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        paymentJournal: state.paymentJournal.paymentJournal,
        legalEntities: state.paymentJournal.legalEntities
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getList: () => dispatch(Actions.getPaymentJournalList()),
            create: (legalEntityId: number, site: number) =>
                dispatch(Actions.createPaymentJournal(legalEntityId, site)),
            view: (id: number) => dispatch(Actions.getPaymentJournal(id))
        }
    };
}

interface IActions {
    getList: () => Promise<any>;
    create: (legalEntityId: number, site: number) => Promise<any>;
    view: (id: number) => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentJournalsPage);
